export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13742.dd05f77d.jpg";